/**
 * @author Yaochao
 * @date 2022/2/16 16:00
 * @description
 */
import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from 'react'
import {Badge, Input, Layout, Menu, Spin, Tabs} from "antd"
import IconSearch from "../../iconfont/search";
import {Link} from 'react-router-dom'
import {CheckOutlined, LoadingOutlined,} from '@ant-design/icons';
import LogoCollapsed from "../../images/layout/logo_collapsed.svg";
import IconDeleteAccount from "./iconfont/deleteAccount/deleteAccount";
import Util from "../public/utils";
import CloudApi from "../cloud/cloud_api";
import ZkModal from "../common/modal/zkModal";
import modal_warning from "../cloud/image/customer/groupsend/modal_warning.png";
import IconDeleteTag from "./iconfont/deleteTag/deleteTag";
import {Path} from "../public/path";
import Logo from "../../images/layout/logo_white.svg";
import PubSub from "pubsub-js";
import RightClick from "./common/rightclick/rightclick";
import {Item} from "react-contexify";

const {SubMenu} = Menu;
const {TabPane} = Tabs;
const {Header, Sider, Content} = Layout;
const WXWAccount = forwardRef((props, ref) => {
    const [defaultSelectedKeys, setDefaultSelectedKeys] = useState([''])//默认
    const [selectedKeys, setSelectedKeys] = useState([''])//选中的
    const [data, setData] = useState([])//存放所以的联系人的数据
    const [filterData, setFilterData] = useState([])//存放所以的联系人的数据
    const [searchData, setSearchData] = useState([])//存放所以的联系人的数据
    const [pathMap, setPathMap] = useState({})
    const [linkMan, setLinkMan] = useState(false)//搜索联系人的焦点事件
    const [searchAccount, setSearchAccount] = useState('')//搜索联系人的字段
    const [deleteLinkManWxid, setDeleteLinkManWxid] = useState(null)//删除联系人的wxid
    const [selectId, setSelectId] = useState('')//选中的联系人的wxid
    const [loading, setLoading] = useState(true)
    const deleteLinkManRef = useRef(null);
    const [sysSwitchVisible, setSysSwitchVisible] = useState(false);

    useEffect(() => {
        Spin.setDefaultIndicator(<LoadingOutlined style={{fontSize: 24, marginTop: '20px'}} spin/>)
        //请求关联的账号
        getData()
    }, [])

    useEffect(() => {
        if (props.wxid) {
            let strArr = []
            data.forEach((item, index) => {
                if (item.wxid == props.wxid) {
                    props.getWxAccount(item)
                    strArr.push(index)
                    let strArr1 = strArr.map(String)
                    setSelectedKeys(strArr1)
                }
            })
        }
    }, [props.wxid])
    useEffect(() => {

    }, [])

    // useEffect(() => {
    //     let newData = data
    //     newData.forEach((item, index) => {
    //         if (item.wxid == props.msgNum.wxid) {
    //             item.notReadNum = props.msgNum.notReadNum ? props.msgNum.notReadNum : ''
    //         }
    //     })
    //     setData(newData)
    //     // setFilterData(newData)
    //     // setSearchData(newData)
    // }, [props.msgNum])

    useImperativeHandle(ref, () => ({
        getData: getData,
        queryLinkMan: queryLinkMan,
        isValidAccountFromServer: isValidAccountFromServer,
        heartBeatChange: heartBeatChange,
        popUp: popUp,
        openChatMessageChange: openChatMessageChange,
        closeChatMessageChange: closeChatMessageChange,
        getMsgNum: getMsgNum,
    }));

    //新消息来了改变未读数
    function getMsgNum(msgNum) {
        let newData = [...data]
        newData.forEach((item, index) => {
            if (item.wxid == msgNum.wxid) {
                item.notReadNum = msgNum.notReadNum ? msgNum.notReadNum : ''
            }
        })
        setData(newData)
    }

    //上线
    function popUp(wxid) {
        let newData = data
        newData.forEach((item, index) => {
            if (item.wxid == wxid) {
                item.status = 1
            }
        })
        let arr = newData.filter(el => el.wxid == wxid)
        let str = newData.filter(el => el.wxid != wxid)
        if (arr.length > 0) {
            let index = str.findIndex(item => arr[0].status == item.status && arr[0].modId < item.modId);
            str.splice(index, 0, arr[0]);
        }
        let strArr = []
        str.forEach((item, index) => {
            if (item.wxid == Util.getUrlArg('wxid')) {
                strArr.push(index)
                let strArr1 = strArr.map(String)
                setSelectedKeys(strArr1)
                props.getWxAccount(item)
            }
        })
        setData(str)
    }

    //离线的
    function heartBeatChange(wxid) {
        let newData = data
        newData.forEach((item) => {
            if (item.wxid == wxid) {
                item.status = 2
            }
        })
        let arr = newData.filter(el => el.wxid == wxid)
        let str = newData.filter(el => el.wxid != wxid)
        if (arr.length > 0) {
            let index = str.findIndex(item => arr[0].status == item.status && arr[0].modId < item.modId);
            str.splice(index, 0, arr[0]);
        }
        let strArr = []
        str.forEach((item, index) => {
            if (item.wxid == Util.getUrlArg('wxid')) {
                strArr.push(index)
                let strArr1 = strArr.map(String)
                setSelectedKeys(strArr1)
                props.getWxAccount(item)
            }
        })
        setData(str)
    }

    //打开新的会话
    function openChatMessageChange(list) {
        let newData = data//原数组
        if (newData.length == 0) {
            let strArr = []
            newData.push(list)
            strArr.push(0)
            let strArr1 = strArr.map(String)
            setSelectedKeys(strArr1)
            props.getWxAccount(list)
            setData(newData)
        } else {
            let arr = newData.some(el => el.wxid == list.wxid) //判断原数组里面又没有
            // console.log(newData, '前')
            if (arr == false) { //如果没有才往里面加
                let index = newData && newData.findIndex(item => list.status == item.status && list.modId < item.modId);
                // console.log(index, newData, list, '999')
                newData.splice(index, 0, list);
                let strArr = []
                newData.forEach((item, index) => {
                    if (item.wxid == Util.getUrlArg('wxid')) {
                        strArr.push(index)
                        let strArr1 = strArr.map(String)
                        setSelectedKeys(strArr1)
                        props.getWxAccount(item)
                    }
                })
                setData(newData)
            }
        }
        if (newData.length == 0) {
            props.setNeed(true)
        } else {
            props.setNeed(false)
        }
        // console.log(newData, '后')
    }

    //关闭会话
    function closeChatMessageChange(list) {
        let newData = data//原数组
        if (newData.length == 1 && newData[0].wxid == list.wxid) {
            setData([])
            props.setNeed(true)
        } else {
            // console.log(newData, '原数组')
            let arr = data.filter(item => item.wxid != list.wxid)
            if (arr.length == 0) {
                props.setNeed(true)
            } else {
                props.setNeed(false)
            }
            setData(arr)
            // console.log(arr, '过滤的数组')
            let strArr = []
            let flag = arr.some(item => item.wxid == Util.getUrlArg('wxid'))
            if (flag == true) {
                arr.forEach((item, index) => {
                    if (item.wxid == Util.getUrlArg('wxid')) {
                        strArr.push(index)
                        let strArr1 = strArr.map(String)
                        setSelectedKeys(strArr1)
                        props.getWxAccount(arr[index])
                    }
                })
            } else {
                let ind = newData.findIndex(el => el.wxid == Util.getUrlArg('wxid'))
                if (arr[ind] == undefined) {
                    strArr.push(ind - 1)
                    let strArr1 = strArr.map(String)
                    setSelectedKeys(strArr1)
                    props.getWxAccount(arr[ind - 1])
                } else {
                    strArr.push(ind)
                    let strArr1 = strArr.map(String)
                    setSelectedKeys(strArr1)
                    props.getWxAccount(arr[ind])
                }
            }
        }

    }

    function isValidAccountFromServer(wxid) {
        for (let account of data) {
            if (account.wxid == wxid) {
                return true
            }
        }
        return false;
    }


    function getData() {
        setLoading(true)
        let wxid = Util.getUrlArg('wxid')//获取路径上的参数
        if (wxid == null) {
            let strArr = []
            CloudApi.getChatAccountList((data) => {
                if (data.list.length == 0) {
                    props.setNeed(true)
                } else {
                    props.setNeed(false)
                }
                data.list.forEach((item, index) => {
                    if (index == 0) {
                        strArr.push(index)
                        let strArr1 = strArr.map(String)
                        setSelectedKeys(strArr1)
                        props.getWxAccount(item)
                        setSelectId(item.wxid)
                    }
                })
                setData(data.list)
                // setData([])
                setFilterData(data.list)
                setSearchData(data.list)
                setLoading(false)
            }, () => {
                // Message.error('获取账号列表失败')
            })
        } else {
            let strArr = []
            CloudApi.getChatAccountList((data) => {
                if (data.list.length == 0) {
                    props.setNeed(true)
                } else {
                    props.setNeed(false)
                }
                data.list.forEach((item, index) => {
                    if (wxid == item.wxid) {
                        strArr.push(index)
                        let strArr1 = strArr.map(String)
                        setSelectedKeys(strArr1)
                        props.getWxAccount(item)
                        setSelectId(item.wxid)
                    }
                })
                setData(data.list)
                // setData([])
                setFilterData(data.list)
                setSearchData(data.list)
                setLoading(false)
            }, () => {
                // Message.error('获取账号列表失败')
            })
        }
    }

    function toggle() {
        props.aFold()
    }

    //点击左侧的账号
    function menuClick(item, index, e) {
        let strArr = [index]
        let strArr1 = strArr.map(String)
        setSelectedKeys(strArr1)
        props.getWxAccount(item)
        setSelectId(item.wxid)
    }


    function linkManFocus() {
        setLinkMan(true)
    }

    function linkManBlur() {
        setLinkMan(false)
    }

    //搜索账号的变化事件
    function searchAccountChange(e) {
        setSearchAccount(e.target.value)
        if (e.target.value == '') {
            let newData = [...searchData]
            setData(newData)
        }
    }

    //搜索回车事件
    function pressEnter() {
        let newData = [...filterData]
        let searchData = newData.filter((item) => {
            return item.nickname.indexOf(searchAccount) != -1
        })
        let wxid = Util.getUrlArg('wxid')
        let strArr = []
        searchData.forEach((item, index) => {
            if (item.wxid == wxid) {
                strArr.push(index)
                let strArr1 = strArr.map(String)
                setSelectedKeys(strArr1)
            }
        })
        setData(searchData)
    }

    //点击删除左侧的联系人
    function deleteLinkMan(id, e) {
        e = e || window.event;
        if (e.stopPropagation) { //W3C阻止冒泡方法
            e.stopPropagation();
        } else {
            e.cancelBubble = true; //IE阻止冒泡方法
        }
        setDeleteLinkManWxid(id)
        deleteLinkManRef.current.show()
    }

    //点击删除联系人弹框的确定按钮
    function queryLinkMan(id) {
        let bodyData = {
            wxid: id ? id : deleteLinkManWxid,
            openChat: 0
        }
        CloudApi.getChatRadio(bodyData, () => {
            deleteLinkManRef.current.hide()
        }, () => {
        })
    }

    //左侧联系人收起时点击搜索按钮展开
    function clickSearch() {
        if (props.collapsed == true) {
            props.unfoldLinkMan()
            setLinkMan(true)
        }
    }

    function clearSearchAccount() {
        setSearchAccount('')
        let newData = [...searchData]
        setData(newData)
    }

    let menu = (
        <Menu className={'sysSwitchMenu'}>
            <Menu.Item key="1" title={''}><Link
                to={Path.getDashboard()}><CheckOutlined/>紫鲲</Link></Menu.Item>
            <Menu.Item key="2" title={''} className='active'><Link
                to={Path.getZkCloudHome()}><CheckOutlined/>企微助手Pro</Link></Menu.Item>
        </Menu>
    );

    //点击联系人的置顶
    function linkManTop(item, index) {
        let bodyData = {
            wxwUserId: item.wxid,
            topFlag: item.topFlag == 0 ? 1 : 0
        }
        let newData = [...filterData]//原数组
        CloudApi.getAccountTopFlag(bodyData, () => {
            newData.forEach((el, ind) => {
                if (el.wxid == bodyData.wxwUserId) {
                    el.topFlag = bodyData.topFlag
                }
            })
            let onLine = [], offLine = []
            onLine = newData.filter(item => item.status == 1) //在线的联系人
            let onLine_stick = onLine.filter(item => item.topFlag == 1) //在线置顶
            let onLine_no_stick = onLine.filter(item => item.topFlag == 0) //在线不置顶
            onLine = [...onLine_stick, ...onLine_no_stick]

            offLine = newData.filter(item => item.status == 2) //离线的联系人
            let offLine_stick = offLine.filter(item => item.topFlag == 1) //离线置顶
            let offLine_no_stick = offLine.filter(item => item.topFlag == 0) //离线不置顶
            offLine = [...offLine_stick, ...offLine_no_stick]
            let newArr = [...onLine, ...offLine]
            setData(newArr)
            newArr.forEach((item, index) => {
                if (item.wxid == bodyData.wxwUserId) {
                    menuClick(item, index)
                }
            })
        }, () => {
        })
    }

    function getItems(item, index) {
        return (
            <>
                <Item style={{lineHeight: '22px'}}
                      onClick={linkManTop.bind(this, item, index)}>{item.topFlag == 0 ? '置顶' : '取消置顶'}</Item>
                <Item style={{lineHeight: '22px'}} onClick={deleteLinkMan.bind(this, item.wxid)}>关闭</Item>
            </>
        )
    }

    //默认触发一次事件
    return (
        <div className={'management_account'}>
            <div className={props.collapsed ? "qy-logo qy-logo-collapse" : 'qy-logo'}>
                <a>
                    {
                        props.collapsed ?
                            <Link to={Path.getZkCloudSeat()}>
                                <img height={32} src={LogoCollapsed}/>
                            </Link> :
                            <Link to={Path.getZkCloudSeat()}>
                                <img height={32} src={Logo}/>
                            </Link>
                    }
                </a>
                {/*{*/}
                {/*    !props.collapsed ?*/}
                {/*        <span className={'btn'} onClick={toggle}>*/}
                {/*            {React.createElement(props.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}*/}
                {/*        </span> : ''*/}
                {/*}*/}
            </div>
            <div className={props.collapsed == true ? 'link_man_search link_man_cut_down' : 'link_man_search'}>
                <Input
                    className={linkMan ? 'link_man_background' : ''}
                    placeholder={props.collapsed == true ? '' : '请输入账号昵称'}
                    onFocus={linkManFocus}//获取焦点
                    onBlur={linkManBlur}//失去焦点
                    value={searchAccount}
                    onChange={searchAccountChange}
                    onPressEnter={pressEnter}
                />
                {
                    searchAccount.length > 0 ?
                        <label className={'link_man_search_clear'} onClick={clearSearchAccount}>
                            {/*清除*/}
                            <IconDeleteTag/>
                        </label> :
                        <label onClick={clickSearch}>
                            {/*搜索*/}
                            <IconSearch/>
                        </label>
                }
            </div>
            <Spin spinning={loading} style={{background: '#222222'}}>
                <Menu theme="dark" mode="inline"
                      style={{background: '#222222'}}
                      defaultSelectedKeys={defaultSelectedKeys}
                      selectedKeys={selectedKeys}
                >
                    {
                        data && data.map((item, index) => {
                            return <Menu.Item key={index}
                                              title={<div className={'pack_up_side'}>
                                                  <label>
                                                      <span>{item.nickname}</span>
                                                      <span>{item.status == 1 ? '[在线]' : item.status == 2 ? '[离线]' : ''}</span>
                                                  </label>
                                                  <span>{item.shortCorpName}</span>
                                              </div>}
                                              onClick={menuClick.bind(this, item, index)}
                                              className={item.wxid == selectId && item.status == 2 ? 'offlineSelected' : item.status == 2 ? 'off_line_state' : ''}
                            >
                                <RightClick key={item.wxid} menuId={"linkMan" + index}
                                            item={getItems(item, index)}>
                                    <Badge offset={props.collapsed == false ? [-10, 1] : [-15, 1]}
                                           count={item.notReadNum ? item.notReadNum : ''}>
                                        <img src={item.avatar} style={{width: '42px'}}/>
                                    </Badge>
                                    <span
                                        className={item.status == 1 ? 'dot_on_line dot' : item.status == 2 ? 'dot_off_line dot' : ''}></span>
                                    <div className={'left_link_man_style'}>
                                    <span>
                                        {item.nickname}
                                        <label>{item.status == 1 ? '[在线]' : item.status == 2 ? '[离线]' : ''}</label>
                                    </span>
                                        <span className={'name_of_firm'}>{item.shortCorpName}</span>
                                    </div>
                                    {/*<span className={'delete_account'}*/}
                                    {/*      onClick={deleteLinkMan.bind(this, item.wxid)}><IconDeleteAccount/></span>*/}
                                </RightClick>
                            </Menu.Item>

                        })
                    }
                </Menu>
            </Spin>
            <ZkModal
                title={''} ref={deleteLinkManRef} width={520} onOk={queryLinkMan}
                className={'modal-right-btn'}
            >
                <div className={'modal-tip-content'}>
                    <img src={modal_warning}/>
                    <div>【是否确认关闭在线聊天】</div>
                </div>
                <div className={'send-modal-text'}>
                    {'关闭后，需要到聊天配置中开启'}
                </div>
            </ZkModal>
        </div>
    )
});

export default WXWAccount